/*
 * @Author: Json Chen
 * @Date: 2021-06-30 13:02:36
 * @LastEditTime: 2021-06-30 13:02:36
 * @LastEditors: Json Chen
 * @Description:
 * @FilePath: /unifyxp-v2-store-portal/src/hooks/useResetFormOnCloseModal.ts
 */
import React from 'react';

const useResetFormOnCloseModal = ({
  form,
  visible,
}: {
  form: FormInstance;
  visible: boolean;
}) => {
  const prevVisibleRef = React.useRef<boolean>();
  React.useEffect(() => {
    prevVisibleRef.current = visible;
  }, [visible]);
  const prevVisible = prevVisibleRef.current;

  React.useEffect(() => {
    if (!visible && prevVisible) {
      form.resetFields();
    }
  }, [visible]);
};

export default useResetFormOnCloseModal;
